import StreamLineIconsComponent from './StreamLineIconsComponent.vue'

//- The icons (vue-svg-loader will load any .svg as a component)
import slBynlogo from './BYN_Logo.svg'
import slBynlogoNegativ from './BYN_Logo_Negativ.svg'
import slHome from './Streamline/app/house.svg'
import slSettings from './Streamline/app/cog-double.svg'
import slClose from './Streamline/app/close.svg'
import slAlarm from './Streamline/app/alarm-bell.svg'
import slBankID from './Streamline/app/jp-bankid_monochr.svg'
import slMyAddress from './Streamline/app/jp-smart-house-phone-outline.svg'
import slHamburger from './Streamline/app/navigation-menu.svg'
import slMenu from './Streamline/app/navigation-menu-vertical.svg'
import slBullets from './Streamline/app/list-bullets-1.svg'
import slQuestion from './Streamline/app/question-circle.svg'
import slEbook from './Streamline/app/notes-check.svg'
import slEbookAdd from './Streamline/app/notes-add.svg'
import slBookFlip from './Streamline/app/book-flip-page.svg'
import slManual from './Streamline/app/book-play.svg'
import slStairsAscend from './Streamline/app/stairs-ascend.svg'
import slArrangeLetter from './Streamline/actions/arrange-letter.svg'

import slMobile from './Streamline/devices/mobile-phone.svg'
import slEmail from './Streamline/devices/email-action-unread.svg'

import slDelete from './Streamline/actions/bin-paper-1.svg'
import slCancel from './Streamline/actions/delete-1.svg'
import slCancel2 from './Streamline/actions/delete-2.svg'
import slSend from './Streamline/actions/send-email.svg'
import slUpload from './Streamline/actions/common-file-upload.svg'
import slphoto from './Streamline/actions/social-photobucket.svg'
import slView from './Streamline/actions/view-1.svg'
import slNotification from './Streamline/actions/messages-bubble-square-text.svg'
import slLogout from './Streamline/actions/logout-2.svg'
import slLogin from './Streamline/actions/login-3.svg'
import slSave from './Streamline/actions/check-circle-1.svg'
import slSaveFilled from './Streamline/actions/check-circle-1-filled.svg'
import slBanned from './Streamline/actions/road-sign-banned.svg'
import slQr from './Streamline/actions/qr-code.svg'
import slSteperCheck from './Streamline/actions/jp-stepper-check-circle-1.svg'
import slEdit from './Streamline/actions/pencil-2.svg'
import slWrite from './Streamline/actions/pencil-write-3.svg'
import slSearch from './Streamline/actions/search.svg'
import slLike from './Streamline/actions/like-2.svg'
import slDislike from './Streamline/actions/dislike-2.svg'
import slStop from './Streamline/actions/stop-sign.svg'
import slUndo from './Streamline/actions/undo.svg'
import slnavigationCircle from './Streamline/actions/navigation-right-circle.svg'
import slFilter from './Streamline/actions/filter.svg'
import slSort from './Streamline/actions/paragraph-spacing.svg'
import slConfirm from './Streamline/actions/lock-password.svg'
import slAdd from './Streamline/actions/add.svg'
import slGuide from './Streamline/actions/outdoors-landscape.svg'
import slLink from './Streamline/actions/hyperlink-3.svg'
import slUnLink from './Streamline/actions/link-broken.svg'
import slCalendar from './Streamline/actions/calendar.svg'
import slRemove from './Streamline/actions/remove.svg'
import slChecked from './Streamline/actions/check-square.svg'
import slPause from './Streamline/actions/controls-pause.svg'
import slAttachment from './Streamline/actions/attachment.svg'
import slCircle from './Streamline/actions/sign-badge-circle.svg'
import slTranslate from './Streamline/actions/chat-translate.svg'
import slJpChecked from './Streamline/actions/jp-check-square-bold.svg'
import slJpCheckedLocked from './Streamline/actions/jp-check-square-bold-locked.svg'
import slJpUnchecked from './Streamline/actions/jp-uncheck-square-bold.svg'
import slHammer from './Streamline/actions/tools-hammer-hold.svg'
import slNoteAdd from './Streamline/actions/notes-add.svg'
import slAddApplication from './Streamline/actions/common-file-text-add.svg'
import slFile from './Streamline/actions/common-file-text.svg'
import slConversationChatbubble from './Streamline/actions/conversation-chat-bubble.svg'
import slInvoice from './Streamline/actions/accounting-invoice.svg'
import slDelivery from './Streamline/actions/shipment-box.svg'
import slCamera from './Streamline/actions/camera-1.svg'
import slSingleNeutralActionsCheck from './Streamline/actions/single-neutral-actions-check-1.svg'
import slspinner from './Streamline/actions/rolling.svg'
import slInvitation from './Streamline/app/invitation.svg'
import slWindowExpand from './Streamline/actions/app-window-expand.svg'
import slPasswordType from './Streamline/actions/password-type.svg'
import slCopyPaste from './Streamline/actions/copy-paste.svg'
import slTaskFingerShow from './Streamline/actions/task-finger-show.svg'
import slTaskListApprove from './Streamline/actions/task-list-approve.svg'

import slLvl1 from './Streamline/ebook/l1n.svg'
import slLvl2 from './Streamline/ebook/l2n.svg'
import slLvl3 from './Streamline/ebook/l3n.svg'
import slLvl4 from './Streamline/ebook/l4n.svg'
import slCheck1 from './Streamline/ebook/check-1.svg'
import slCheck2 from './Streamline/ebook/check-double-1.svg'
import slCheck3 from './Streamline/ebook/jp-check-star.svg'
import slCompleted from './Streamline/ebook/ebook-completed.svg'
import slNotesChecklistFlip from './Streamline/ebook/notes-checklist-flip.svg'
import slOwl from './Streamline/ebook/study-owl.svg'
import slClock from './Streamline/ebook/time-clock-circle.svg'
import slNotes from './Streamline/ebook/notes-paper-text.svg'
import slEbookApprove from './Streamline/ebook/business-contract-approve.svg'

import slInfo from './Streamline/alerts/information-circle.svg'
import slInfoSmallFilled from './Streamline/alerts/information-circle-small-filled.svg'
import slAlert from './Streamline/alerts/alert-circle.svg'
import slTriangle from './Streamline/alerts/triangel-handledare.svg'
import slWarning from './Streamline/alerts/road-sign-warning.svg'
import slCheckCircle from './Streamline/alerts/check-circle-1.svg'

import slApplication from './Streamline/application/business-contract-approve.svg'
import slApproveOrder from './Streamline/application/notes-paper-approve.svg'
import slQuestionSquare from './Streamline/application/question-help-square.svg'

import slCompany from './Streamline/company/building-daylight.svg'
import slWorkplace from './Streamline/company/construction-house-1.svg'
import slPermissions from './Streamline/company/login-key.svg'
import slDepartments from './Streamline/company/human-resources-hierarchy.svg'
import slDepartmentsAdmin from './Streamline/company/human-resources-hierarchy-1.svg'
import slMeeting from './Streamline/company/team-meeting.svg'

import slArrowDown from './Streamline/directions/arrow-down-1.svg'
import slArrowLeft from './Streamline/directions/arrow-left-1.svg'
import slArrowRight from './Streamline/directions/arrow-right-1.svg'
import slArrowUp from './Streamline/directions/arrow-up-1.svg'
import slNavLeft from './Streamline/directions/navigation-left.svg'
import slGoRight from './Streamline/directions/navigation-right-circle.svg'

import slStaff from './Streamline/person/multiple-users-1.svg'
import slInstructor from './Streamline/person/professions-man-construction-1.svg'
import slApprentice from './Streamline/person/read-human.svg'
import slYUA from './Streamline/person/school-teacher-a.svg'
import slAdmin from './Streamline/person/history-man-king.svg'
import slUser from './Streamline/person/single-neutral-circle.svg'
import slDistanceAdmin from './Streamline/person/single-neutral-actions-money.svg'
import slApprentices from './Streamline/person/team-meeting.svg'
import slUnderage from './Streamline/person/baby.svg'
//import slDistanceAdmin from './Streamline/person/single-woman-actions-money.svg'

import slTradecertificate from './Streamline/tradecertificate/certified-diploma-1.svg'

import slProfessionDiver from './Streamline/professions/professions-man-diver.svg'
import slFence from './Streamline/professions/construction-fence.svg'
import slCarbide from './Streamline/professions/hardware-drill-carbide.svg'
import slEquipmentCleaner1 from './Streamline/professions/heavy-equipment-cleaner-1.svg'
import slEquipmentCleaner from './Streamline/professions/heavy-equipment-cleaner.svg'
import slExcavator from './Streamline/professions/heavy-equipment-excavator-1.svg'
import slEquipmentFlattenerfrom from './Streamline/professions/heavy-equipment-flattener.svg'
import slEquipmentLift from './Streamline/professions/heavy-equipment-lift-2.svg'
import slEquipmentLiftBox from './Streamline/professions/heavy-equipment-mortar-truck-2.svg'
import slEquipmentTruck from './Streamline/professions/heavy-equipment-truck.svg'
import slExplosive from './Streamline/professions/explosive.svg'
import slPumpDriver from './Streamline/professions/jp-heavy-equipment-concrete-pump-driver.svg'
import slPileDriver from './Streamline/professions/jp-heavy-equipment-pile-driver.svg'
import slWallDriver from './Streamline/professions/jp-heavy-equipment-retaining-wall-driver.svg'
import slshipmentCraneHook from './Streamline/professions/shipment-crane-hook.svg'
import slconstructionBrick from './Streamline/professions/material-brick.svg'
import slMaterialStone from './Streamline/professions/material-stone.svg'
import slIsolation from './Streamline/professions/material-isolation.svg'
import slMaterialTileRoof1 from './Streamline/professions/material-tile-roof-1.svg'
import slMaterialTileRoof from './Streamline/professions/material-tile-roof.svg'
import slMaterialTile from './Streamline/professions/material-tile.svg'
import slhardwareHammerNail from './Streamline/professions/hardware-hammer-nail-hit.svg'
import slRoadSign from './Streamline/professions/road-sign.svg'
import slStars from './Streamline/professions/stairs.svg'
import slMask from './Streamline/professions/protection-mask-1.svg'
import slTractor from './Streamline/professions/agriculture-machine-tractor-2.svg'
import slRoadScraper from './Streamline/professions/jp-heavy-equipment-road-scraper.svg'
import slSciencePhysics from './Streamline/professions/jp-telescopic-handler.svg'
import slShipmentHook from './Streamline/professions/shipment-hook.svg'
import slEquipmentHook from './Streamline/professions/heavy-equipment-hook.svg'
import slToolsFlattenerTriangle from './Streamline/professions/tools-flattener-triangle.svg'

import slJpg from './Streamline/files/image-file-jpg.svg'
import slPng from './Streamline/files/image-file-png.svg'
import slPdf from './Streamline/files/office-file-pdf-1.svg'
import slMissingFile from './Streamline/files/common-file-empty.svg'

import slApprovedByApprentice from './Streamline/status/approvedByApprentice.svg'
import slApprovedByCompany from './Streamline/status/approvedByCompany.svg'
import slStatusPaid from './Streamline/status/status-paid.svg'
import slApplicationStatusDraft from './Streamline/status/aplicationdraft.svg'

//Statuses
import slDraft from './Streamline/status/draft.svg'
import slError from './Streamline/status/error.svg'
import slConfirmedByCompany from './Streamline/status/confirmedByCompany.svg'
import slConfirmedByStudent from './Streamline/status/confirmedByStudent.svg'
import slConfirmedAndApprovedByCompany from './Streamline/status/confirmedAndApprovedByCompany.svg'
import slApproved from './Streamline/status/approved.svg'
import slOrdered from './Streamline/status/ordered.svg'
import slClosed from './Streamline/status/closed.svg'

const SLIcons = {
  //- application icons
  'sl-logo': { component: StreamLineIconsComponent, props: { cmp: slBynlogo } },
  'sl-logo-negativ': { component: StreamLineIconsComponent, props: { cmp: slBynlogoNegativ } },
  'sl-home': { component: StreamLineIconsComponent, props: { cmp: slHome } },
  'sl-settings': { component: StreamLineIconsComponent, props: { cmp: slSettings } },
  'sl-attachment': { component: StreamLineIconsComponent, props: { cmp: slAttachment } },
  'sl-close': { component: StreamLineIconsComponent, props: { cmp: slClose } },
  'sl-bankid': { component: StreamLineIconsComponent, props: { cmp: slBankID } },
  'sl-my-address': { component: StreamLineIconsComponent, props: { cmp: slMyAddress } },
  'sl-hamburger': { component: StreamLineIconsComponent, props: { cmp: slHamburger } },
  'sl-menu': { component: StreamLineIconsComponent, props: { cmp: slMenu } },
  'sl-bullets': { component: StreamLineIconsComponent, props: { cmp: slBullets } },
  'sl-question': { component: StreamLineIconsComponent, props: { cmp: slQuestion } },
  'sl-ebook': { component: StreamLineIconsComponent, props: { cmp: slEbook } },
  'sl-ebook-add': { component: StreamLineIconsComponent, props: { cmp: slEbookAdd } },
  'sl-book-flip': { component: StreamLineIconsComponent, props: { cmp: slBookFlip } },
  'sl-manual': { component: StreamLineIconsComponent, props: { cmp: slManual } },
  'sl-stairs-ascend': { component: StreamLineIconsComponent, props: { cmp: slStairsAscend } },
  'sl-arrange-letter': { component: StreamLineIconsComponent, props: { cmp: slArrangeLetter } },
  'sl-invitation': { component: StreamLineIconsComponent, props: { cmp: slInvitation } },
  'sl-window-expand': { component: StreamLineIconsComponent, props: { cmp: slWindowExpand } },

  //- Devives
  'sl-mobile': { component: StreamLineIconsComponent, props: { cmp: slMobile } },
  'sl-email': { component: StreamLineIconsComponent, props: { cmp: slEmail } },

  //- Files icons
  'sl-jpg': { component: StreamLineIconsComponent, props: { cmp: slJpg } },
  'sl-png': { component: StreamLineIconsComponent, props: { cmp: slPng } },
  'sl-pdf': { component: StreamLineIconsComponent, props: { cmp: slPdf } },
  'sl-missing-file': { component: StreamLineIconsComponent, props: { cmp: slMissingFile } },
  'sl-alarm': { component: StreamLineIconsComponent, props: { cmp: slAlarm } },

  //- common actions
  'sl-delete': { component: StreamLineIconsComponent, props: { cmp: slDelete } },
  'sl-cancel': { component: StreamLineIconsComponent, props: { cmp: slCancel } },
  'sl-cancel2': { component: StreamLineIconsComponent, props: { cmp: slCancel2 } },
  'sl-send': { component: StreamLineIconsComponent, props: { cmp: slSend } },
  'sl-upload': { component: StreamLineIconsComponent, props: { cmp: slUpload } },
  'sl-logout': { component: StreamLineIconsComponent, props: { cmp: slLogout } },
  'sl-login': { component: StreamLineIconsComponent, props: { cmp: slLogin } },
  'sl-edit': { component: StreamLineIconsComponent, props: { cmp: slEdit } },
  'sl-write': { component: StreamLineIconsComponent, props: { cmp: slWrite } },
  'sl-banned': { component: StreamLineIconsComponent, props: { cmp: slBanned } },
  'sl-qr': { component: StreamLineIconsComponent, props: { cmp: slQr } },
  'sl-search': { component: StreamLineIconsComponent, props: { cmp: slSearch } },
  'sl-photo': { component: StreamLineIconsComponent, props: { cmp: slphoto } },
  'sl-notification': { component: StreamLineIconsComponent, props: { cmp: slNotification } },
  'sl-save': { component: StreamLineIconsComponent, props: { cmp: slSave } },
  'sl-save-filled': { component: StreamLineIconsComponent, props: { cmp: slSaveFilled } },
  'sl-view': { component: StreamLineIconsComponent, props: { cmp: slView } },
  'sl-steper-check': { component: StreamLineIconsComponent, props: { cmp: slSteperCheck } },
  'sl-like': { component: StreamLineIconsComponent, props: { cmp: slLike } },
  'sl-dislike': { component: StreamLineIconsComponent, props: { cmp: slDislike } },
  'sl-stop': { component: StreamLineIconsComponent, props: { cmp: slStop } },
  'sl-undo': { component: StreamLineIconsComponent, props: { cmp: slUndo } },
  'sl-navigation-right-circle': { component: StreamLineIconsComponent, props: { cmp: slnavigationCircle } },
  'sl-filter': { component: StreamLineIconsComponent, props: { cmp: slFilter } },
  'sl-sort': { component: StreamLineIconsComponent, props: { cmp: slSort } },
  'sl-confirm': { component: StreamLineIconsComponent, props: { cmp: slConfirm } },
  'sl-add': { component: StreamLineIconsComponent, props: { cmp: slAdd } },
  'sl-guide': { component: StreamLineIconsComponent, props: { cmp: slGuide } },
  'sl-link': { component: StreamLineIconsComponent, props: { cmp: slLink } },
  'sl-unlink': { component: StreamLineIconsComponent, props: { cmp: slUnLink } },
  'sl-calendar': { component: StreamLineIconsComponent, props: { cmp: slCalendar } },
  'sl-remove': { component: StreamLineIconsComponent, props: { cmp: slRemove } },
  'sl-checked': { component: StreamLineIconsComponent, props: { cmp: slChecked } },
  'sl-circle': { component: StreamLineIconsComponent, props: { cmp: slCircle } },
  'sl-translate': { component: StreamLineIconsComponent, props: { cmp: slTranslate } },
  'sl-check': { component: StreamLineIconsComponent, props: { cmp: slJpChecked } },
  'sl-check-locked': { component: StreamLineIconsComponent, props: { cmp: slJpCheckedLocked } },
  'sl-uncheck': { component: StreamLineIconsComponent, props: { cmp: slJpUnchecked } },
  'sl-hammer': { component: StreamLineIconsComponent, props: { cmp: slHammer } },
  'sl-note-add': { component: StreamLineIconsComponent, props: { cmp: slNoteAdd } },
  'sl-add-application': { component: StreamLineIconsComponent, props: { cmp: slAddApplication } },
  'sl-file': { component: StreamLineIconsComponent, props: { cmp: slFile } },
  'sl-conversation-chat-buble': { component: StreamLineIconsComponent, props: { cmp: slConversationChatbubble } },
  'sl-invoice': { component: StreamLineIconsComponent, props: { cmp: slInvoice } },
  'sl-delivery': { component: StreamLineIconsComponent, props: { cmp: slDelivery } },
  'sl-camera': { component: StreamLineIconsComponent, props: { cmp: slCamera } },
  'sl-single-neutral-actions-check': { component: StreamLineIconsComponent, props: { cmp: slSingleNeutralActionsCheck } },
  'sl-spinner': { component: StreamLineIconsComponent, props: { cmp: slspinner } },
  'sl-password-type': { component: StreamLineIconsComponent, props: { cmp: slPasswordType } },
  'sl-copy-paste': { component: StreamLineIconsComponent, props: { cmp: slCopyPaste } },
  'sl-task-finger-show': { component: StreamLineIconsComponent, props: { cmp: slTaskFingerShow } },
  'sl-task-list-approve': { component: StreamLineIconsComponent, props: { cmp: slTaskListApprove } },

  //- ebook
  'sl-ebook-lvl1': { component: StreamLineIconsComponent, props: { cmp: slLvl1 } },
  'sl-ebook-lvl2': { component: StreamLineIconsComponent, props: { cmp: slLvl2 } },
  'sl-ebook-lvl3': { component: StreamLineIconsComponent, props: { cmp: slLvl3 } },
  'sl-ebook-lvl4': { component: StreamLineIconsComponent, props: { cmp: slLvl4 } },
  'sl-check1': { component: StreamLineIconsComponent, props: { cmp: slCheck1 } },
  'sl-check2': { component: StreamLineIconsComponent, props: { cmp: slCheck2 } },
  'sl-check3': { component: StreamLineIconsComponent, props: { cmp: slCheck3 } },
  'sl-completed': { component: StreamLineIconsComponent, props: { cmp: slCompleted } },
  'sl-checklist-flip': { component: StreamLineIconsComponent, props: { cmp: slNotesChecklistFlip } },
  'sl-owl': { component: StreamLineIconsComponent, props: { cmp: slOwl } },
  'sl-clock': { component: StreamLineIconsComponent, props: { cmp: slClock } },
  'sl-notes': { component: StreamLineIconsComponent, props: { cmp: slNotes } },
  'sl-ebook-approve': { component: StreamLineIconsComponent, props: { cmp: slEbookApprove } },

  //- alerts
  'sl-info': { component: StreamLineIconsComponent, props: { cmp: slInfo } },
  'sl-info-small-filled': { component: StreamLineIconsComponent, props: { cmp: slInfoSmallFilled } },
  'sl-alert': { component: StreamLineIconsComponent, props: { cmp: slAlert } },
  'sl-triangle': { component: StreamLineIconsComponent, props: { cmp: slTriangle } },
  'sl-warning': { component: StreamLineIconsComponent, props: { cmp: slWarning } },
  'sl-check-circle': { component: StreamLineIconsComponent, props: { cmp: slCheckCircle } },

  //- apprentice application
  'sl-apprentice-application': { component: StreamLineIconsComponent, props: { cmp: slApplication } },
  'sl-approve-distance-order': { component: StreamLineIconsComponent, props: { cmp: slApproveOrder } },
  'sl-question-square': { component: StreamLineIconsComponent, props: { cmp: slQuestionSquare } },

  //- company related
  'sl-company': { component: StreamLineIconsComponent, props: { cmp: slCompany } },
  'sl-workplace': { component: StreamLineIconsComponent, props: { cmp: slWorkplace } },
  'sl-permissions': { component: StreamLineIconsComponent, props: { cmp: slPermissions } },
  'sl-departments': { component: StreamLineIconsComponent, props: { cmp: slDepartments } },
  'sl-departments-admin': { component: StreamLineIconsComponent, props: { cmp: slDepartmentsAdmin } },
  'sl-meeting': { component: StreamLineIconsComponent, props: { cmp: slMeeting } },

  //- directions
  'sl-arrow-down': { component: StreamLineIconsComponent, props: { cmp: slArrowDown } },
  'sl-arrow-left': { component: StreamLineIconsComponent, props: { cmp: slArrowLeft } },
  'sl-arrow-right': { component: StreamLineIconsComponent, props: { cmp: slArrowRight } },
  'sl-arrow-up': { component: StreamLineIconsComponent, props: { cmp: slArrowUp } },
  'sl-navigate-left': { component: StreamLineIconsComponent, props: { cmp: slNavLeft } },
  'sl-go-right': { component: StreamLineIconsComponent, props: { cmp: slGoRight } },

  //- person icons
  'sl-staff': { component: StreamLineIconsComponent, props: { cmp: slStaff } },
  'sl-pause': { component: StreamLineIconsComponent, props: { cmp: slPause } },
  'sl-instructor': { component: StreamLineIconsComponent, props: { cmp: slInstructor } },
  'sl-apprentice': { component: StreamLineIconsComponent, props: { cmp: slApprentice } },
  'sl-yua': { component: StreamLineIconsComponent, props: { cmp: slYUA } },
  'sl-admin': { component: StreamLineIconsComponent, props: { cmp: slAdmin } },
  'sl-user': { component: StreamLineIconsComponent, props: { cmp: slUser } },
  //'sl-user-gb': {component: StreamLineIconsComponent, props: {cmp: slUserGB}},
  'sl-apprentices': { component: StreamLineIconsComponent, props: { cmp: slApprentices } },
  'sl-underage': { component: StreamLineIconsComponent, props: { cmp: slUnderage } },
  'sl-distance-admin': { component: StreamLineIconsComponent, props: { cmp: slDistanceAdmin } },

  //- tradecertificates
  'sl-trade-certificate': { component: StreamLineIconsComponent, props: { cmp: slTradecertificate } },

  //- professions
  'sl-professions-man-diver': { component: StreamLineIconsComponent, props: { cmp: slProfessionDiver } },
  'sl-construction-fence': { component: StreamLineIconsComponent, props: { cmp: slFence } },
  'sl-hardware-drill-carbide': { component: StreamLineIconsComponent, props: { cmp: slCarbide } },
  'sl-equipment-cleaner1': { component: StreamLineIconsComponent, props: { cmp: slEquipmentCleaner1 } },
  'sl-heavy-equipment-cleaner': { component: StreamLineIconsComponent, props: { cmp: slEquipmentCleaner } },
  'sl-jp-heavy-equipment-pile-driver': { component: StreamLineIconsComponent, props: { cmp: slPileDriver } },
  'sl-jp-heavy-equipment-wall-driver': { component: StreamLineIconsComponent, props: { cmp: slWallDriver } },
  'sl-heavy-equipment-excavator-1': { component: StreamLineIconsComponent, props: { cmp: slExcavator } },
  'sl-heavy-equipment-flattener': { component: StreamLineIconsComponent, props: { cmp: slEquipmentFlattenerfrom } },
  'sl-equipment-lift': { component: StreamLineIconsComponent, props: { cmp: slEquipmentLift } },
  'sl-heavy-equipment-lift-hook-box': { component: StreamLineIconsComponent, props: { cmp: slEquipmentLiftBox } },
  'sl-equipment-truck': { component: StreamLineIconsComponent, props: { cmp: slEquipmentTruck } },
  'sl-material-isolation': { component: StreamLineIconsComponent, props: { cmp: slIsolation } },
  'sl-mask': { component: StreamLineIconsComponent, props: { cmp: slMask } },
  'sl-explosive': { component: StreamLineIconsComponent, props: { cmp: slExplosive } },
  'sl-jp-heavy-equipment-concrete-pump-driver': { component: StreamLineIconsComponent, props: { cmp: slPumpDriver } },
  'sl-shipment-crane-hook': { component: StreamLineIconsComponent, props: { cmp: slshipmentCraneHook } },
  'sl-material-brick': { component: StreamLineIconsComponent, props: { cmp: slconstructionBrick } },
  'sl-material-stone': { component: StreamLineIconsComponent, props: { cmp: slMaterialStone } },
  'sl-stairs': { component: StreamLineIconsComponent, props: { cmp: slStars } },
  'sl-material-tile-roof-1': { component: StreamLineIconsComponent, props: { cmp: slMaterialTileRoof1 } },
  'sl-material-tile-roof': { component: StreamLineIconsComponent, props: { cmp: slMaterialTileRoof } },
  'sl-material-tile': { component: StreamLineIconsComponent, props: { cmp: slMaterialTile } },
  'sl-hardware-hammer-nail-hit': { component: StreamLineIconsComponent, props: { cmp: slhardwareHammerNail } },
  'sl-road-sign': { component: StreamLineIconsComponent, props: { cmp: slRoadSign } },
  'sl-tractor': { component: StreamLineIconsComponent, props: { cmp: slTractor } },
  'sl-tools-flattener-triangle': { component: StreamLineIconsComponent, props: { cmp: slToolsFlattenerTriangle } },

  'sl-jp-heavy-equipment-road-scraper': { component: StreamLineIconsComponent, props: { cmp: slRoadScraper } },
  'sl-science-physics-law-1': { component: StreamLineIconsComponent, props: { cmp: slSciencePhysics } },
  'sl-shipment-hook': { component: StreamLineIconsComponent, props: { cmp: slShipmentHook } },
  'sl-heavy-equipment-hook': { component: StreamLineIconsComponent, props: { cmp: slEquipmentHook } },

  //  statuses

  'sl-approved-by-apprentice': { component: StreamLineIconsComponent, props: { cmp: slApprovedByApprentice } },
  'sl-approved-by-company': { component: StreamLineIconsComponent, props: { cmp: slApprovedByCompany } },
  'sl-status-paid': { component: StreamLineIconsComponent, props: { cmp: slStatusPaid } },
  'sl-status-draft': { component: StreamLineIconsComponent, props: { cmp: slApplicationStatusDraft } },
  'sl-draft': { component: StreamLineIconsComponent, props: { cmp: slDraft } },
  'sl-error': { component: StreamLineIconsComponent, props: { cmp: slError } },
  'sl-confirmedByCompany': { component: StreamLineIconsComponent, props: { cmp: slConfirmedByCompany } },
  'sl-confirmedByStudent': { component: StreamLineIconsComponent, props: { cmp: slConfirmedByStudent } },
  'sl-confirmedAndApprovedByCompany': {
    component: StreamLineIconsComponent,
    props: { cmp: slConfirmedAndApprovedByCompany }
  },
  'sl-approved': { component: StreamLineIconsComponent, props: { cmp: slApproved } },
  'sl-ordered': { component: StreamLineIconsComponent, props: { cmp: slOrdered } },
  'sl-closed': { component: StreamLineIconsComponent, props: { cmp: slClosed } }
}

export default SLIcons
